import { IAppConfigurationProvider } from '@dirootie-core/core-types';
import { ILogger } from '@dirootie-logging/logging-types';
import { IHttpClient } from '@dirootie-http/http-types';
import { ApiServiceGeneric } from '@dirootie-http/api-types';
//import { WithLogging } from './Logging.decorator';
import { IAppModule, IServiceProvider } from './modules.types';

export class ApiModule implements IAppModule {
  name: string = 'api';

  configureServices(
    serviceProvider: IServiceProvider,
    configProvider: IAppConfigurationProvider
  ): void {
    const logger = serviceProvider.resolve<ILogger>('logger')!;
    const httpClient = serviceProvider.resolve<IHttpClient>('http-client')!;
    const apiService = new ApiServiceGeneric(httpClient, logger);
    serviceProvider.register('api-service',apiService);
  }
}
